// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createAddressButtonStyles } from "@bg/Overrides/Widgets/Addresses/CreateAddressButton";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

createAddressButtonStyles.createNewAddressButton = {
    typographyProps: {
        css: css`
            color: ${getColor("text.main")} !important;
            font-size: 16px;
            line-height: ${fontConfig.lineHeight.small};
            &&:hover,
            &&:focus {
                text-decoration: underline;
            }
        `,
    },
    icon: {
        iconProps: {
            src: "Plus",
            size: 16,
            color: "tertiary.main",
            css: css`
                &:hover,
                &:focus {
                    svg g {
                        color: ${getColor("tertiary.main")};
                    }
                }
            `,
        },
    },
};
